import { motion } from 'framer-motion';
import { CardBack } from '../components/Card.js';

export function Splash() {
  return (
    <div className="grid min-h-full place-items-center px-6">
      <div className="flex flex-col items-center gap-10">
        <div className="relative flex h-44 w-72 items-center justify-center">
          {[0, 1, 2, 3, 4, 5].map((i) => {
            const t = i / 5 - 0.5;
            const rotate = t * 22;
            const dx = t * 160;
            const dy = Math.abs(t) * 18;
            return (
              <motion.div
                key={i}
                className="absolute"
                initial={{ y: 60, opacity: 0, rotate: rotate - 30 }}
                animate={{ y: dy, opacity: 1, rotate }}
                transition={{ delay: 0.05 * i, duration: 0.32, ease: [0.33, 1, 0.68, 1] }}
                style={{ transform: `translate(${dx}px, ${dy}px) rotate(${rotate}deg)` }}
              >
                <CardBack size="lg" />
              </motion.div>
            );
          })}
        </div>
        <motion.div
          initial={{ scale: 0.92, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.32, ease: [0.34, 1.56, 0.64, 1] }}
          className="text-center"
        >
          <h1 className="heading-display text-5xl tracking-wide">DURAK</h1>
          <p className="mt-2 text-sm text-ivory-soft/80">Подкидной · Telegram Stars</p>
        </motion.div>
      </div>
    </div>
  );
}
